export const authHeader = function ()
{
    const accessToken= localStorage.access_token
    const headers = {'headers':{
    'Accept': 'application/json',
    'Authorization': 'Bearer '+ accessToken
    }}

    return headers
}
